import { Transaction } from './transaction'
import { Commons } from '../../utils/commons'

class Formatter {
  static parseExternalTransaction(rawTransaction) {
    if (!rawTransaction) return null
    const transaction = new Transaction()
    let status = rawTransaction.status
    let statusDetailed =
      rawTransaction.dstDetailedStatus ||
      rawTransaction.srcDetailedStatus ||
      status
    if (
      rawTransaction.srcStatus == 'success' &&
      rawTransaction.dstStatus !== 'success'
    ) {
      statusDetailed = 'paidWaiting'
    }

    transaction
      .setReference(rawTransaction.id)
      .setStatus(rawTransaction.status)
      .setStatusCode(statusDetailed)
      .setStartTimestamp(rawTransaction.date)
      .setEndTimestamp(rawTransaction.endDate)
      .setPaymentUrl(rawTransaction.paymentUrl)
      .setOperationName(getOperationName(rawTransaction, true))
      .setOperationType(getOperationType(rawTransaction))
      .setOperationNameDisplay(getOperationName(rawTransaction))
      .setLogo(rawTransaction.operationLogoUrl)
      .setStartDate(
        Commons.timestampToDate(rawTransaction.date, 'DD MMM YYYY - HH:mm'),
      )
      .setEndDate('0')
      .setPaymentReason('')
      .setAmountToSend(rawTransaction.amounts?.srcAmount)
      .setCurrencyToSend(rawTransaction.amounts?.srcCurrency)
      .setAmountToReceive(rawTransaction.amounts?.dstAmount)
      .setCurrencyToReceive(rawTransaction.amounts?.dstCurrency)
      .setFee(rawTransaction.amounts?.totalFee)
      .setFeeCurrency(rawTransaction.amounts?.feeCurrency)
      .setSenderFirstName()
      .setSenderLastName()
      .setRecipientFirstName('')
      .setRecipientLastName('')
      .setSenderAccount('')
      .setRecipientAccount('')
      .setMetaData(formatRawTransaction(rawTransaction))
    return transaction
  }

  static buildTransactionEntity(rawTransaction) {
    if (!rawTransaction) return null
    const transaction = new Transaction()
    transaction
      .setReference(rawTransaction.reference)
      .setStatus(rawTransaction.status)
      .setStatusCode(rawTransaction.statusCode)
      .setStartTimestamp(rawTransaction.startTimestamp)
      .setEndTimestamp(rawTransaction.endTimestamp)
      .setPaymentUrl(rawTransaction.paymentUrl)
      .setOperationName(rawTransaction.operationName)
      .setOperationType(rawTransaction.operationType)
      .setOperationNameDisplay(rawTransaction.operationNameDisplay)
      .setOperationTypeDisplay(rawTransaction.operationTypeDisplay)
      .setStatusToDisplay(rawTransaction.statusToDisplay)
      .setLogo(rawTransaction.logo)
      .setStartDate(rawTransaction.startDate)
      .setEndDate(rawTransaction.endDate)
      .setPaymentReason(rawTransaction.paymentReason)
      .setStatusMessage(rawTransaction.statusMessage)
      .setAmountToSend(rawTransaction.amountToSend)
      .setCurrencyToSend(rawTransaction.currencyToSend)
      .setAmountToReceive(rawTransaction.amountToReceive)
      .setCurrencyToReceive(rawTransaction.currencyToReceive)
      .setFee(rawTransaction.fee)
      .setFeeCurrency(rawTransaction.feeCurrency)
      .setSenderFirstName(rawTransaction.senderFirstName)
      .setSenderLastName(rawTransaction.senderLastName)
      .setRecipientFirstName(rawTransaction.recipientFirstName)
      .setRecipientLastName(rawTransaction.recipientLastName)
      .setSenderAccount(rawTransaction.senderAccount)
      .setRecipientAccount(rawTransaction.recipientAccount)
      .setMetaData(rawTransaction.metaData)
    return transaction
  }
}

const types = {
  fund1xBet: { name: 'Dépot 1xBet', i18nId: 'fund_1xbet', type: '1xbet' },
  fundBetWinner: {
    name: 'Dépot Betwinner',
    i18nId: 'fund_betwinner',
    type: 'betwinner',
  },
  fundMelbet: {
    name: 'Dépot Melbet',
    i18nId: 'fund_melbet',
    type: 'melbet',
  },
  fundEightStarz: {
    name: 'Dépot 888Starz',
    i18nId: 'fund_eightStarz',
    type: 'eightStarz',
  },
  fund1Win: { name: 'Dépot 1Win', i18nId: 'fund_1win', type: '1Win' },
  // fundBookmaker: { name: 'Dépot Bookmaker', i18nId: '', type: '' },
  withdrawal1xBet: {
    name: 'Retrait 1xBet',
    i18nId: 'withdraw_1xbet',
    type: '1xbet',
  },
  withdrawalBetWinner: {
    name: 'Retrait Betwinner',
    i18nId: 'withdraw_betwinner',
    type: 'betwinner',
  },
  withdrawalMelbet: {
    name: 'Retrait Melbet',
    i18nId: 'withdraw_melbet',
    type: 'melbet',
  },
  withdrawalEightStarz: {
    name: 'Retrait 888Starz',
    i18nId: 'withdraw_eightStarz',
    type: 'eightStarz',
  },
  withdrawal1Win: {
    name: 'Retrait 1Win',
    i18nId: 'withdraw_1win',
    type: '1Win',
  },
  // withdrawBookmaker: { name: 'Retrait Bookmaker', i18nId: '', type: '' },
  buyUsdt: { name: 'Achat de USDT', i18nId: 'buy_usdt', type: 'usdt' },
  // buy: { name: 'Achat', i18nId: 'buy_usdt', type: '' },
  sellUsdt: { name: 'Vente de USDT', i18nId: 'sell_usdt', type: 'usdt' },
  sellGiftCard: {
    name: 'Vente de Giftcard',
    i18nId: 'sell_giftcard',
    type: 'giftcard',
  },
  buyGiftCard: {
    name: 'Achat de Giftcard',
    i18nId: 'buy_giftcard',
    type: 'giftcard',
  },
  // sell: { name: 'Vente', i18nId: '', type: '' },
  withdrawalWallet: {
    name: 'Retrait depuis wallet',
    i18nId: 'withdraw_wallet',
    type: 'kingrecharge',
  },
  fundWallet: {
    name: 'Recharge de wallet',
    i18nId: 'fund_wallet',
    type: 'kingrecharge',
  },
  unknown: {
    name: 'Operation Kingrecharge',
    i18nId: 'unknown',
    type: 'kingrecharge',
  },
}

function getOperationName(rawTransaction, i18nId) {
  if (types[rawTransaction.operationType]) {
    const operation = types[rawTransaction.operationType]
    if (i18nId) return operation?.i18nId || 'Opération Kingrecharge'
    return operation?.name || 'Opération Kingrecharge'
  }
  if (rawTransaction.operationType === 'platformSubscription') {
    if (i18nId) return 'platform_subscription_'+rawTransaction.dst?.metadata?.subscription?.metadata?.platformId
    return 'Abonnement ' + rawTransaction.dst?.metadata?.subscription?.name
  }
  if (rawTransaction.operationType === 'subscription') {
    if (i18nId) return 'subscription'
    return 'Abonnement VIP'
  }
  return 'opération KingRecharge'
}

function getOperationType(rawTransaction) {
  if (types[rawTransaction.operationType]) {
    const operation = types[rawTransaction.operationType]
    return operation?.type || 'kingrecharge'
  }
  return rawTransaction.operationType || 'kingrecharge'
}

function formatRawTransaction(transaction) {
  let subscriptionStatus = ''
  let subscriptionExpirationDate = ''
  if (transaction.operationType == 'platformSubscription') {
    const monthInMs = 30 * 24 * 60 * 60 * 1000
    const durationInMs = transaction.dst.metadata.duration * monthInMs
    subscriptionExpirationDate = transaction.date + durationInMs
    const isExprired = subscriptionExpirationDate < Date.now()
    if (transaction.status !== 'success')
      subscriptionStatus = transaction.status
    else if (isExprired) subscriptionStatus = 'expired'
    else subscriptionStatus = 'active'
  }

  return {
    ...transaction,
    subscriptionStatus,
    subscriptionExpirationDate,
  }
}

export { Formatter }
